export default "/images/6db660dddc46a2d9684b4c68be58c1a7.avif";